import { Select, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useGetGradingConfigurations } from "@hooks";
import { useTranslation } from "react-i18next";

interface Props {
  value?: string;
  onChange?: (value: string | undefined) => void;
  disabled?: boolean;
}

export const GradingConfigurationSelect = ({ value, onChange, disabled }: Props) => {
  const { t } = useTranslation();
  const { data: gradingConfigurations, isLoading } = useGetGradingConfigurations();

  const handleChange = (selectedValue: string | undefined) => {
    onChange?.(selectedValue || undefined);
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      loading={isLoading}
      disabled={disabled}
      allowClear
      placeholder={t("pages.examsManagment.primarySettingsTab.gradingConfigPlaceholder", "Select grading configuration")}
      options={gradingConfigurations?.map((config) => ({
        value: config.id,
        label: (
          <span>
            {config.name}
            {config.description && (
              <Tooltip title={config.description}>
                <QuestionCircleOutlined style={{ marginLeft: 8 }} />
              </Tooltip>
            )}
          </span>
        ),
      }))}
    />
  );
};
